import "./BlogPost.css";

interface BlogPostProps {
  key: number;
  title: string;
  date: string;
  excerpt: string;
  url: string;
}

export default function BlogPost({
  key,
  title,
  date,
  excerpt,
  url,
}: BlogPostProps) {
  return (
    <a href={url} className="detail-container blog-post-item">
      <h3>{title}</h3>
      <p>{excerpt}</p>
      <div className="see-full-post-span">
        <span>See full post on LinkedIn</span>
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          color="currentColor"
        >
          <path
            d="M6.00005 19L19 5.99996M19 5.99996V18.48M19 5.99996H6.52005"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>
    </a>
  );
}
